import { render, staticRenderFns } from "./OfficeView.vue?vue&type=template&id=ecada9d6&"
import script from "./OfficeView.vue?vue&type=script&lang=js&"
export * from "./OfficeView.vue?vue&type=script&lang=js&"
import style0 from "./OfficeView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports